module.exports = __webpack_public_path__ + "img/18_29.71a727da.png";